import { ClickAwayListener, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import Filter from "../icons/Filter/Filter";

const useStyles = makeStyles({
    wrapper: {
        display: 'contents',
        position: 'relative',
    },
    panel: {
        top: '50%',
        font: 'initial',
        left: '50%',
        width: 'max-content',
        maxWidth: '70vw',
        cursor: 'default',
        padding: '1rem',
        zIndex: '1000',
        position: 'absolute',
        transform: 'translateX(-100%)',
        boxShadow: '0 0 .5rem 0 rgba(0 0 0 / .3)',
        fontFamily: 'inherit',
        borderRadius: '.5rem',
        backgroundColor: 'white',
        borderTopRightRadius: '0',
        textAlign: 'initial',
        color: 'initial',
    },
    hidden: {
        display: 'none',
    },
});

const FilterAction = ({ children, open, onClose }) => {
    const styles = useStyles();
    return <div className={styles.wrapper}>
        <Filter />
        <ClickAwayListener mouseEvent={open ? "onClick" : false} touchEvent={open ? "onTouchEnd" : false} onClickAway={onClose}>
            <div onClick={(e) => {
                e.stopPropagation();
            }} className={[styles.panel, !open ? styles.hidden : null].join(" ")}>
                {children}
            </div>
        </ClickAwayListener>
    </div>;
};

export default FilterAction;
